import { initSection } from '../../core/shopify/init-section/index.js';
import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
const NAMESPACE = '.js-generic-carousel-section';
initSection(NAMESPACE, (section)=>{
    const swiperEl = section.querySelector('.js-generic-carousel');
    if (!swiperEl) return {
        unload: null
    };
    Swiper.use([
        Navigation,
        Pagination,
        Lazy
    ]);
    const swiper = new Swiper(swiperEl, {
        navigation: {
            nextEl: section.querySelector('.js-generic-carousel-next'),
            prevEl: section.querySelector('.js-generic-carousel-prev')
        },
        pagination: {
            el: section.querySelector('.js-generic-carousel-pagination'),
            type: 'progressbar'
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 12,
        lazy: {
            loadPrevNext: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 28
            }
        }
    });
    return {
        unload: ()=>{
            swiper.destroy(true, true);
        }
    };
});
